import React from 'react';
import FadeoutErrorMessage from '../../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import {Departments} from "../../../../lib/systemVariables";

export default class LocationGroupInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            deletingError: false,
            errorMessage: ''
        };
    }

    showModal() {
        if (this.state.deletingError || this.state.errorMessage) this.setState({ deletingError: false, errorMessage: '' });
        this.props.showModal();
    }

    async deleteSetting(id) {
        if (this.state.deletingError || this.state.errorMessage) this.setState({ deletingError: false, errorMessage: '' });
        await this.props.delete(id);
        if (this.props.deleting[id] && !this.props.deleting[id].success) {
            if (this.props.deleting[id] && this.props.deleting[id].message) this.setState({ errorMessage: this.props.deleting[id].message });
            else this.setState({ deletingError: true });
        }
    }

    render() {

        const { locationGroups } = this.props;
        return (
            <div>
                <div className="flex-justify flex-center signature-label">
                    <label className="input-label">Location Groups</label>
                    <a className="link-text xs-text" onClick={this.showModal.bind(this)}>Add New</a>
                </div>
                <div className="chip-container">
                    {locationGroups.map((group) =>
                        <div className="location-tooltip-container" key={group.groupId}>
                            <div className="chip" >
                                <span onClick={this.props.onClick.bind(null, group.groupId)}>{group.groupName}</span>
                                {(this.props.deleting[group.groupId] && this.props.deleting[group.groupId].loading) ? <LoadingSpinner loading={this.props.deleting[group.groupId] && this.props.deleting[group.groupId].success} />
                                : <i className="material-icons delete-chip" onClick={this.deleteSetting.bind(this, group.groupId)}>close</i>}
                            </div>
                            {!(group.department === Departments.IL && group.members.length === 1 && !group.members[0].city) && <div className="location-tooltip">
                                <p><span className="bold-text">{group.groupName}</span> Location Group</p>
                                <div className="location-tooltip-chips">
                                    {group.members.map((member, index) =>
                                        <div className="chip" key={index}><span>{member.city}, {member.country === 'United States' ? member.state : member.country}</span></div>
                                    )}
                                </div>
                            </div>}
                        </div>
                    )}
                </div>
                <FadeoutErrorMessage show={this.state.deletingError || this.state.errorMessage} message={this.state.errorMessage || "Could not delete setting"} timeOut={5000}/>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/campaignSettings/LocationGroupInput.jsx